// extracted by mini-css-extract-plugin
export default {"root":"notifier_root__vKpqt","heading":"notifier_heading__pTZWt","label":"notifier_label__xqCKU"};